// Precificação (preço de venda) — "por quanto eu vendo isso e ainda lucro?"
// ÚNICA com a divisão pro-cliente/minha-cópia (revela lucro) — mas isso é
// decisão de EXPORTAÇÃO; a função só calcula. docs/calculamei-spec-calculadoras.md §1.

export type LucroTipo = 'reais' | 'percentual'

export interface PrecificacaoInputs {
  custoMaterial: number
  custoMaoObra: number
  /** Embalagem, frete, taxa da maquininha por item (opcional). */
  outrosCustos: number
  lucroTipo: LucroTipo
  /** Em R$ (lucroTipo='reais') ou em % SOBRE O PREÇO (lucroTipo='percentual'). */
  lucroValor: number
}

export interface PrecificacaoResultado {
  custoTotal: number
  precoVenda: number
  lucro: number
  /** % do preço que é lucro (margem sobre a venda). */
  margemSobreVenda: number
  /** Multiplicador sobre o custo (precoVenda / custoTotal), ex.: 2,5×. */
  markup: number
  /** false quando não dá pra calcular ainda (custo total = 0). */
  calculavel: boolean
}

const round2 = (n: number) => Number(n.toFixed(2))

export function calcularPrecificacao(inputs: PrecificacaoInputs): PrecificacaoResultado {
  const { custoMaterial, custoMaoObra, outrosCustos, lucroTipo, lucroValor } = inputs

  const custoTotal = (custoMaterial || 0) + (custoMaoObra || 0) + (outrosCustos || 0)

  if (custoTotal <= 0) {
    return {
      custoTotal: 0,
      precoVenda: 0,
      lucro: 0,
      margemSobreVenda: 0,
      markup: 0,
      calculavel: false,
    }
  }

  let precoVenda: number
  let lucro: number

  if (lucroTipo === 'reais') {
    lucro = lucroValor || 0
    precoVenda = custoTotal + lucro
  } else {
    // % é margem SOBRE O PREÇO (decisão 1): preço = custo / (1 − margem/100).
    // Capamos abaixo de 100% pra não estourar (divisão por zero / negativo).
    const margem = Math.min(Math.max(lucroValor || 0, 0), 99.99)
    precoVenda = custoTotal / (1 - margem / 100)
    lucro = precoVenda - custoTotal
  }

  const margemSobreVenda = precoVenda > 0 ? (lucro / precoVenda) * 100 : 0
  const markup = precoVenda / custoTotal

  return {
    custoTotal: round2(custoTotal),
    precoVenda: round2(precoVenda),
    lucro: round2(lucro),
    margemSobreVenda: round2(margemSobreVenda),
    markup: round2(markup),
    calculavel: true,
  }
}
